"use client";

import React from "react";
import Image from "next/image";
import Link from "next/link";
import { motion } from "framer-motion";
import { Button } from "../components/ui/button";

const NotFoundPage = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#FFFFFFE6] relative overflow-hidden">
      {/* Background Logo Image - Reduced opacity */}
      <div className="absolute inset-0 w-full h-full">
        <Image
          src="/logoo.svg"
          alt="Background Logo"
          fill
          className="object-contain opacity-5"
          priority
        />
      </div>

      {/* Main Content */}
      <motion.div
        className="relative z-10 text-center px-6 max-w-lg"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <motion.h1
          className="text-7xl md:text-9xl font-bricolage font-bold text-[#1B1B1B] mb-4"
          initial={{ scale: 0.8 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.3, delay: 0.2 }}
        >
          404
        </motion.h1>
        <motion.p
          className="text-2xl md:text-3xl font-jakarta font-semibold text-[#1B1B1B] mb-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3, delay: 0.4 }}
        >
          Oops! Page Not Found
        </motion.p>
        <motion.p
          className="text-lg font-jakarta text-[#1B1B1B] mb-8"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3, delay: 0.6 }}
        >
          It looks like you’ve wandered off the path. Let’s get you back home!
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.8 }}
        >
          <Button
            asChild
            className="bg-[#FFAE00] text-black hover:bg-[#e69b00] px-6 py-3 rounded-xl font-jakarta font-bold text-xl tracking-[0.20px] transition-colors duration-200"
          >
            <Link href="/">Return to Home</Link>
          </Button>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default NotFoundPage;
